import { j as e } from "../../_virtual/jsx-runtime.js";
import * as x from "react";
import { cn as i } from "../../lib/utils.js";
import { ResponsiveContainer as R } from "../../node_modules/recharts/es6/component/ResponsiveContainer.js";
const S = { light: "", dark: ".dark" }, k = x.createContext(null);
function N() {
  const o = x.useContext(k);
  if (!o)
    throw new Error("useChart must be used within a <ChartContainer />");
  return o;
}
const E = x.forwardRef(({ id: o, className: r, children: n, config: t, ...a }, f) => {
  const l = `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`, c = `chart-${o || l.replace(/:/g, "")}`;
  return /* @__PURE__ */ e.jsx(k.Provider, { value: { config: t }, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      "data-chart": c,
      ref: f,
      className: i(
        "flex aspect-video justify-center text-xs [&_.recharts-cartesian-axis-tick_text] [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-none [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-sector]:outline-none [&_.recharts-surface]:outline-none",
        r
      ),
      ...a,
      children: [
        /* @__PURE__ */ e.jsx(M, { id: c, config: t }),
        /* @__PURE__ */ e.jsx(R, { children: n })
      ]
    }
  ) });
});
E.displayName = "Chart";
const M = ({ id: o, config: r }) => {
  const n = Object.entries(r).filter(
    ([, t]) => t.theme || t.color
  );
  return n.length ? /* @__PURE__ */ e.jsx(
    "style",
    {
      dangerouslySetInnerHTML: {
        __html: Object.entries(S).map(
          ([t, a]) => `
${a} [data-chart=${o}] {
${n.map(([f, l]) => {
            var h;
            const c = ((h = l.theme) == null ? void 0 : h[t]) || l.color;
            return c ? `  --color-${f}: ${c};` : null;
          }).join(`
`)}
}
`
        ).join(`
`)
      }
    }
  ) : null;
}, P = x.forwardRef(
  ({
    active: o,
    payload: r,
    className: n,
    indicator: t = "dot",
    hideLabel: a = !1,
    hideIndicator: f = !1,
    label: l,
    labelFormatter: c,
    labelClassName: h,
    formatter: u,
    color: C,
    nameKey: $,
    labelKey: b
  }, L) => {
    const { config: m } = N(), _ = x.useMemo(() => {
      var v;
      if (a || !(r != null && r.length))
        return null;
      const [s] = r, p = `${b || s.dataKey || s.name || "value"}`, g = w(m, s, p), d = !b && typeof l == "string" ? ((v = m[l]) == null ? void 0 : v.label) || l : g == null ? void 0 : g.label;
      return c ? /* @__PURE__ */ e.jsx("div", { className: i("font-medium", h), children: c(d, r) }) : d ? /* @__PURE__ */ e.jsx("div", { className: i("font-medium", h), children: d }) : null;
    }, [
      l,
      c,
      r,
      a,
      h,
      m,
      b
    ]);
    if (!o || !(r != null && r.length))
      return null;
    const j = r.length === 1 && t !== "dot";
    return /* @__PURE__ */ e.jsxs(
      "div",
      {
        ref: L,
        className: i(
          "grid min-w-[8rem] items-start gap-1.5 rounded-lg border border-border/50 bg-background px-2.5 py-1.5 text-xs shadow-xl",
          n
        ),
        children: [
          j ? null : _,
          /* @__PURE__ */ e.jsx("div", { className: "grid gap-1.5", children: r.map((s, p) => {
            const g = `${$ || s.name || s.dataKey || "value"}`, d = w(m, s, g), v = C || s.payload.fill || s.color;
            return /* @__PURE__ */ e.jsx(
              "div",
              {
                className: i(
                  "flex w-full flex-wrap items-stretch gap-2 [&>svg]:h-2.5 [&>svg]:w-2.5 [&>svg]:text-muted-foreground",
                  t === "dot" && "items-center"
                ),
                children: u && (s == null ? void 0 : s.value) !== void 0 && s.name ? u(s.value, s.name, s, p, s.payload) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                  d != null && d.icon ? /* @__PURE__ */ e.jsx(d.icon, {}) : !f && /* @__PURE__ */ e.jsx(
                    "div",
                    {
                      className: i(
                        "shrink-0 rounded-[2px] border-[--color-border] bg-[--color-bg]",
                        {
                          "h-2.5 w-2.5": t === "dot",
                          "w-1": t === "line",
                          "w-0 border-[1.5px] border-dashed bg-transparent": t === "dashed",
                          "my-0.5": j && t === "dashed"
                        }
                      ),
                      style: {
                        "--color-bg": v,
                        "--color-border": v
                      }
                    }
                  ),
                  /* @__PURE__ */ e.jsxs(
                    "div",
                    {
                      className: i(
                        "flex flex-1 justify-between leading-none",
                        j ? "items-end" : "items-center"
                      ),
                      children: [
                        /* @__PURE__ */ e.jsxs("div", { className: "grid gap-1.5", children: [
                          j ? _ : null,
                          /* @__PURE__ */ e.jsx("span", { className: "text-muted-foreground", children: (d == null ? void 0 : d.label) || s.name })
                        ] }),
                        s.value && /* @__PURE__ */ e.jsx("span", { className: "font-mono font-medium tabular-nums text-foreground", children: s.value.toLocaleString() })
                      ]
                    }
                  )
                ] })
              },
              s.dataKey
            );
          }) })
        ]
      }
    );
  }
);
P.displayName = "ChartTooltip";
const T = x.forwardRef(
  ({ className: o, hideIcon: r = !1, payload: n, verticalAlign: t = "bottom", nameKey: a }, f) => {
    const { config: l } = N();
    return n != null && n.length ? /* @__PURE__ */ e.jsx(
      "div",
      {
        ref: f,
        className: i(
          "flex items-center justify-center gap-4",
          t === "top" ? "pb-3" : "pt-3",
          o
        ),
        children: n.map((c) => {
          const h = `${a || c.dataKey || "value"}`, u = w(l, c, h);
          return /* @__PURE__ */ e.jsxs(
            "div",
            {
              className: i(
                "flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3 [&>svg]:text-muted-foreground"
              ),
              children: [
                u != null && u.icon && !r ? /* @__PURE__ */ e.jsx(u.icon, {}) : /* @__PURE__ */ e.jsx(
                  "div",
                  {
                    className: "h-2 w-2 shrink-0 rounded-[2px]",
                    style: {
                      backgroundColor: c.color
                    }
                  }
                ),
                u == null ? void 0 : u.label
              ]
            },
            c.value
          );
        })
      }
    ) : null;
  }
);
T.displayName = "ChartLegend";
function w(o, r, n) {
  if (typeof r != "object" || r === null)
    return;
  const t = "payload" in r && typeof r.payload == "object" && r.payload !== null ? r.payload : void 0;
  let a = n;
  return n in r && typeof r[n] == "string" ? a = r[n] : t && n in t && typeof t[n] == "string" && (a = t[n]), a in o ? o[a] : o[n];
}
export {
  E as ChartContainer,
  T as ChartLegendContent,
  M as ChartStyle,
  P as ChartTooltipContent
};
